/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestApproveLinkRequestModel } from '../model/models';
import { ApiRequestApproveLinkRequestsModel } from '../model/models';
import { ApiRequestDisconnectMultipleUsers } from '../model/models';
import { ApiRequestDisconnectUser } from '../model/models';
import { ApiRequestUpdateUserRole } from '../model/models';
import { ApiResponseSuccessModel } from '../model/models';
import { ChildConnectedUser } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EmployerUserManagementServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestModel 
     */
    employerUserManagementControllerApproveUserConnection0(apiRequestApproveLinkRequestModel: ApiRequestApproveLinkRequestModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestModel 
     */
    employerUserManagementControllerApproveUserConnection1(apiRequestApproveLinkRequestModel: ApiRequestApproveLinkRequestModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestsModel 
     */
    employerUserManagementControllerApproveUserConnections0(apiRequestApproveLinkRequestsModel: ApiRequestApproveLinkRequestsModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestsModel 
     */
    employerUserManagementControllerApproveUserConnections1(apiRequestApproveLinkRequestsModel: ApiRequestApproveLinkRequestsModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestDisconnectUser 
     */
    employerUserManagementControllerDisconnectUser0(apiRequestDisconnectUser: ApiRequestDisconnectUser, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestDisconnectUser 
     */
    employerUserManagementControllerDisconnectUser1(apiRequestDisconnectUser: ApiRequestDisconnectUser, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestDisconnectMultipleUsers 
     */
    employerUserManagementControllerDisconnectUsers0(apiRequestDisconnectMultipleUsers: ApiRequestDisconnectMultipleUsers, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestDisconnectMultipleUsers 
     */
    employerUserManagementControllerDisconnectUsers1(apiRequestDisconnectMultipleUsers: ApiRequestDisconnectMultipleUsers, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param employerId 
     */
    employerUserManagementControllerGetPendingJoinRequests0(employerId: string, extraHttpRequestParams?: any): Observable<Array<ChildConnectedUser>>;

    /**
     * 
     * 
     * @param employerId 
     */
    employerUserManagementControllerGetPendingJoinRequests1(employerId: string, extraHttpRequestParams?: any): Observable<Array<ChildConnectedUser>>;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestModel 
     */
    employerUserManagementControllerRejectUserConnection0(apiRequestApproveLinkRequestModel: ApiRequestApproveLinkRequestModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestApproveLinkRequestModel 
     */
    employerUserManagementControllerRejectUserConnection1(apiRequestApproveLinkRequestModel: ApiRequestApproveLinkRequestModel, extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     * @param apiRequestUpdateUserRole 
     */
    employerUserManagementControllerUpdateUserRole0(apiRequestUpdateUserRole: ApiRequestUpdateUserRole, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param apiRequestUpdateUserRole 
     */
    employerUserManagementControllerUpdateUserRole1(apiRequestUpdateUserRole: ApiRequestUpdateUserRole, extraHttpRequestParams?: any): Observable<boolean>;

}
